<template>
    <div class="games-page">
        <div class="page-head">
            <div class="left">
                <h1>Games</h1>
            </div>

        </div>
        <GameList ref="GameList" />
    </div>
</template>

<script>
    import GameList from "@/components/Games/GameList";

    export default {
        name: "Games",
        components: {
            GameList,
        },

        methods: {

        },
        mounted() {}
    };
</script>

<style scoped></style>
